import React, {useMemo} from "react";

import {DishDetailsItem} from "@apps/dish/interfaces";

import {MenuCategoryItem} from "@components/Menu/interfaces";

import CategoryBanner0 from "./CategoryBanner0/CategoryBanner0";
import CategoryBanner1 from "./CategoryBanner1/CategoryBanner1";

interface MenuItemsProps {
  categories: MenuCategoryItem[];
  items: {
    [key: string]: DishDetailsItem;
  };
  preSelectedItemSlug?: string;
}

export default function MenuItems({
  categories,
  items,
  preSelectedItemSlug,
}: MenuItemsProps): JSX.Element {
  const menuItemList = useMemo(() => {
    if (!categories) {
      return [];
    }
    return categories.reduce((allItems, category) => {
      const categoryItems = category.item_ids.map((id) => items[id]);
      return allItems.concat(categoryItems);
    }, [] as DishDetailsItem[]);
  }, [categories, items]);

  return (
    <>
      {categories?.map((category: MenuCategoryItem) => {
        const hasPreSelectedItem = Object.values(items).some(
          (item) => item.slug === preSelectedItemSlug
        );
        return category.banner_style === 0 ? (
          <CategoryBanner0
            key={`${category.id}-${category.name}`}
            category={category}
            items={items}
            menuItemList={menuItemList}
            isInitiallyCollapsed={!hasPreSelectedItem}
          />
        ) : (
          <CategoryBanner1
            key={`${category.id}-${category.name}`}
            category={category}
            items={items}
            menuItemList={menuItemList}
          />
        );
      })}
    </>
  );
}
